const state = {
  reviews: {
    isLoading: false,
    data: [],
    pagination: {
      totalElements: 0,
      startReverseIndex: 0,
    },
  },
  review: {},
  reports: {
    isLoading: false,
    data: [],
    pagination: {
      totalElements: 0,
      startReverseIndex: 0,
    },
  },
};

export default state;
